import RegistrationStepper from "./RegistrationStepper";

const Registration = () => {
  return <RegistrationStepper />;
};

export default Registration;
